import type { AxiosError } from 'axios';
import { upperFirst } from 'lodash-es';

/** Extracts the human-readable messages from a 400 response body, if any. */
export const extractErrorsIfBadRequest = (error: AxiosError) => {
  if (error.response?.status === 400) {
    const data = error.response?.data;

    if (data == null) {
      return [];
    }

    const datas = Array.isArray(data) ? data : [data];
    const contentType = error.response.headers?.['content-type'];
    const isJson = typeof contentType === 'string' && contentType.includes('application/json');

    if (isJson) {
      return datas.map((d) => (upperFirst(d.message) !== '' ? upperFirst(d.message) : JSON.stringify(d)));
    }

    return datas;
  }
  return [];
};
